import React, { Component,useState } from 'react';
import { withRouter } from 'react-router-dom'
import InputWithExtra from '../../../Comman/components/InputWithExtra';
import { Redirect } from 'react-router-dom'
import {ToastContainer,toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import loader from '../../../Comman/images/loader.gif';
import { withNamespaces } from 'react-i18next';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var svValidator;
var engValidator;
class AddHeartRunnerComponent extends Component {
    constructor(props) {
        super(props);
        this.state={
            addHeartRunner: {
                FirstName: '',
                LastName: '',
                AliasName:'',
                Phone: '',
                CountryCode : '46',
                EmailId: '',
                Username: '',
                Password: '', 
                RegionId:null,               
                confirmPassword: '',                
                IsApproved:1,
                // CertificateID:'',
                // resourceName :'',
                // organizationName:'',
                WorkingPlace : '',
                Proffession  : '',
                CPREducation : '',
                PermissionId:[],
                UserType:'Admin',
                Permissions:[]
              },
        }
        this.baseState=this.state;
        /*this.addDeviceDetails = this.addDeviceDetails.bind(this);*/
    }

    componentWillMount() {
      SimpleReactValidator.addLocale('en', {
        required : 'The :attribute field is required.',
        min : 'The :attribute must be at least :min:type.',
        max : 'The :attribute may not be greater than :max:type.',
        email : 'The :attribute must be a valid email address.', 
      });
      SimpleReactValidator.addLocale('sv', {
        required : 'Fältet :attribute krävs.',
        min : ':attribute måste vara minst :min tecken.',
        max : ':attribute kanske inte är större än :max tecken.',
        email : 'E-postmeddelandet måste vara en giltig e-postadress.'
      });

      engValidator = new SimpleReactValidator({
        locale : 'en',
        validators: {
          allowSwedish: {  // name the rule
            message: 'The :attribute may only contains letters.',
            rule: (val, params, validator) => {
              return validator.helpers.testRegex(val,/^[a-zA-Z åäöÅÄÖ!@#\$%\^\&*\)\(+=._-]+$/g) && params.indexOf(val) === -1
            },
            messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
            required: true  // optional
          },
          phoneValidation: {
            message: 'The phone must be a valid phone number.',
            rule: (val, params, validator) => {
              return validator.helpers.testRegex(val,/^(?=.*[0-9])[ ()0-9]+$/) && params.indexOf(val) === -1
            }
          }
        }
      });

       svValidator = new SimpleReactValidator({
        locale : 'sv',
        validators: {
          allowSwedish: {  // name the rule
            message: ':attribute får endast innehålla bokstäver.',
            rule: (val, params, validator) => {
              return validator.helpers.testRegex(val,/^[a-zA-Z åäöÅÄÖ!@#\$%\^\&*\)\(+=._-]+$/g) && params.indexOf(val) === -1
            },
            messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
            required: true  // optional
          },
          phoneValidation: {
            message: 'Telefonnummer måste vara ett giltigt telefonnummer.',
            rule: (val, params, validator) => {
              return validator.helpers.testRegex(val,/^(?=.*[0-9])[ ()0-9]+$/) && params.indexOf(val) === -1
            }
          }
        }
      });
      this.validator = engValidator;
    }

    handleInput= (e)=> {
      
       let value = e.target.value;
       let name = e.target.name;
       this.setState( prevState => ({ addHeartRunner : 
                {...prevState.addHeartRunner, [name]: value}
          }))
    }

    componentWillReceiveProps(nextProps) {
      const { t } = this.props;
      console.log("next",nextProps.addHeartRunnerDetails);
      console.log("props",this.props.addHeartRunnerDetails)
        if (nextProps.addHeartRunnerDetails !== this.props.addHeartRunnerDetails) {
          if(nextProps.addHeartRunnerDetails.heartRunnerOrgInfo!=undefined){
          if(nextProps.addHeartRunnerDetails.heartRunnerOrgInfo.length >0){
            this.setState({ organizationName: nextProps.addHeartRunnerDetails.heartRunnerOrgInfo[0].OrganizationName}
          )  
          }
        }
            if(nextProps.addHeartRunnerDetails.statusCode==200){
              this.successnotify(nextProps.addHeartRunnerDetails.errorMessage)
              this.successnotify(`${t("First_Responder.Please Sync with dispatcher")}`);
              this.validator.hideMessages();
              this.setState(this.baseState)
            }
            if(nextProps.addHeartRunnerDetails.statusCode==201){
              this.errornotify(nextProps.addHeartRunnerDetails.errorMessage)
            }
        }
            let permissionListData=this.props.addHeartRunnerDetails.permissionList.map(({ ID, Permission,Category }) => {
  return {
   ID, Permission,Category,
  }
})
let RefPermission=permissionListData.filter((i)=>i.Category.toLowerCase()=='admin')
           this.setState( prevState => ({ addHeartRunner : 
                {...prevState.addHeartRunner, Permissions: RefPermission,PermissionId:RefPermission}
          }))
        this.translateLang();
    }

    translateLang(){
      var language;
      if(sessionStorage.getItem('Language')){
        language = sessionStorage.getItem('Language');
      }
      else{
        language = "en";
      }
      if(language == "en"){
        this.validator = engValidator
      }
      else{
        this.validator = svValidator
      }
    }

    addHeartRunner = (event) =>{
       this.setState( prevState => ({ addHeartRunner : 
                {...prevState.addHeartRunner}
          }),()=>{
     const { t } = this.props;
      const Password= this.state.addHeartRunner.Password;
      const confirmPassword= this.state.addHeartRunner.confirmPassword;
       
      let heartRunnerformData= this.state.addHeartRunner;
      heartRunnerformData.OrganizationID= this.props.match.params.id;
       if (Password !== confirmPassword) {
        swal({
          text: `${t("First_Responder.Passwords don't match")}`,
          icon: "error",
        });
      } else {
        if (this.validator.allValid()) {
          let fName = heartRunnerformData.FirstName;
          let lname = heartRunnerformData.LastName;
          let phone = heartRunnerformData.Phone;
          if(phone.charAt(0) == '0'){
            heartRunnerformData.Phone = phone.split('0')[1];
          }
          heartRunnerformData.FirstName = fName.charAt(0).toUpperCase() + fName.slice(1);
          heartRunnerformData.LastName = lname.charAt(0).toUpperCase() + lname.slice(1);              
          heartRunnerformData.Alias = heartRunnerformData.AliasName;
          heartRunnerformData.RegionId = heartRunnerformData.RegionId;
          heartRunnerformData.UserType = heartRunnerformData.UserType;
          heartRunnerformData.PermissionId = heartRunnerformData.PermissionId.map(x=>x.ID);
          if(heartRunnerformData.RegionId==null)
          {
            heartRunnerformData.RegionId= this.props.addHeartRunnerDetails.regionList[0].ID;
          }
           if(!heartRunnerformData.UserType)
          {
            heartRunnerformData.UserType= 'Admin';
          }     

          heartRunnerformData.OrganizationID=this.props.addHeartRunnerDetails.heartRunnerOrgInfo[0].OrganizationID;
          if(this.state.addHeartRunner.EmailId != undefined){
              heartRunnerformData.Username = this.state.addHeartRunner.EmailId
          }
           delete this.state.addHeartRunner.Permissions
          sleep(3000).then(() => {
            console.log("setstate",this.state);
        })
          this.props.addHeartRunner(heartRunnerformData)
         
        } else {
          this.validator.showMessages();
          this.forceUpdate();
        }
          
      }
          })
 
    }

    errornotify = (message) => {
      // toast.error(message+"!", {
      //   position: toast.POSITION.TOP_CENTER
      // });
      swal({text : message, icon : 'error'})
    
    };
    successnotify = (message) => {
      // toast.success(message+"!", {
      //   position: toast.POSITION.TOP_CENTER
      // });
      swal({text : message, icon : 'success'})
      sleep(2000).then(() => {
        this.props.history.push('/superadmin/FirstResponder')
        
      })


    };
  handlePermissionChange = (event) => {
    

       this.setState( prevState => ({ addHeartRunner : 
                {...prevState.addHeartRunner, PermissionId: event}
          }))
          
  }
   permissionType(e){
let value = e.target.value;
       let name = e.target.name;
     
    

       this.setState( prevState => ({ addHeartRunner : 
                {...prevState.addHeartRunner, [name]: value}
          }))
             let permissionListData=this.props.addHeartRunnerDetails.permissionList.map(({ ID, Permission,Category }) => {
  return {
   ID, Permission,Category,
  }
})
         let RefPermission=permissionListData.filter((i)=>i.Category.toLowerCase()==value.toLowerCase())
           this.setState( prevState => ({ addHeartRunner : 
                {...prevState.addHeartRunner, Permissions: RefPermission,PermissionId:RefPermission}
          }))
      console.log(this.state)
      }
    render() {
      const { t } = this.props;
     
      let  countryListOption; 
     let  regionListOption; 
     let permissionOption;
      let regionList=this.props.addHeartRunnerDetails.regionList;
      let permissionListData=this.props.addHeartRunnerDetails.permissionList.map(({ ID, Permission,Category }) => {
  return {
   ID, Permission,Category,
  }
})
     
    
  
  
        let countryListVal = this.props.addHeartRunnerDetails.countryList;
       
        if(countryListVal){
          countryListOption = countryListVal.map((item,index) =>
                <option value={item.CountryCode} key={index}>{item.CountryName} - {item.CountryCode}</option>
            );
        }
        if(regionList){
          regionListOption = regionList.map((item,index) =>
                <option value={item.ID} key={index}>{item.RegionName}</option>
            );
        }
         let rolesType
        if(sessionStorage.getItem('UserType'))
        {
            if(sessionStorage.getItem('UserType')==='SuperAdmin')
            {
              rolesType=  <span>
                <option value={'Superadmin'} key={'Superadmin'}>{t('Superadmin')}</option>
                                                    <option value={'Admin'} key={'Admin'}>{t('Admin')}</option>
                                                     <option value={'User'} key={'User'}>User</option>
              </span>
            }
            if(sessionStorage.getItem('UserType')==='Admin')
            {
              rolesType=  <span>
         
                  <option value={'Admin'} key={'Admin'}>{t('Admin')}</option>
              </span>
            }
        }
        /* let f=[]
        f=permissionListData
      const permissionType=(e)=>{
let value = e.target.value;
       let name = e.target.name;
     
    

       this.setState( prevState => ({ addHeartRunner : 
                {...prevState.addHeartRunner, [name]: value}
          }))
       
f=permissionListData.filter((i)=>i.Category.toLowerCase()==value.toLowerCase())
console.log(f)
      
      } */

        // var orgName;
       
        // if(this.props.addHeartRunnerDetails.heartRunnerOrgInfo!=undefined){
        //   orgName=this.props.addHeartRunnerDetails.heartRunnerOrgInfo.OrganizationName;
        // }
        
        return (
            <div className="container">
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Menu.Add First Responder')}</h2>
                </div>
                
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    {/*this.props.addDetails.errorNumber !== 200 ?
                        <label className="lbl_danger"> {this.props.addDetails.errorMessage !== '' ? this.props.addDetails.errorMessage : ""}</label>
                        : <label className="lbl_success"> {this.props.addDetails.messageLabel !== '' ? this.props.addDetails.messageLabel : ""}</label>*/
                    }
                    {/* <ToastContainer /> */}
                    <div className=" forms add-device setting-panel">
                    <div className="form-three widget-shadow">
                        <div className=" panel-body-inputin">

                        <form className="form-horizontal add-first-resp-label">
                        <div className="form-group">
                            <div className="row">
                              <div className="col-md-1"></div>
                                <div className="col-md-2 radio-label"> 
                                 <label htmlFor="WorkingPlace" className="form-label">{t('First_Responder.WorkingPlace')}</label>
                                </div> 
                                <div className="col-md-8">
                                <InputWithExtra
                                  type={'text'}
                                  title= {'WorkingPlace'} 
                                  name= {'WorkingPlace'}
                                  value={this.state.addHeartRunner.WorkingPlace} 
                                  placeholder = {t('First_Responder.WorkingPlace')}
                                  handleChange = {this.handleInput} /> 
                            </div>    

                                </div>
                              
                              </div>
                              <div className="form-group">
                            <div className="row">
                              <div className="col-md-1"></div>
                                <div className="col-md-2 radio-label"> 
                                 <label htmlFor="Proffession" className="form-label">{t('First_Responder.Proffession')} </label>
                                </div> 
                                <div className="col-md-8">
                                <InputWithExtra
                                  type={'text'}
                                  title= {'Proffession'} 
                                  name= {'Proffession'}
                                  value={this.state.addHeartRunner.Proffession} 
                                  placeholder = {t('First_Responder.Proffession')}
                                  handleChange = {this.handleInput}
                               
                                            />
                            </div>    

                                </div>
                              
                              </div>
                          <div className="form-group">
                            <div className="row">
                              <div className="col-md-1"></div>
                                <div className="col-md-2 radio-label"> 
                                 <label htmlFor="OrganizationName" className="form-label">{t('First_Responder.First Name')}*</label>
                                </div> 
                                <div className="col-md-8">
                                <InputWithExtra
                                  type={'text'}
                                  icon="fa fa-user"
                                  title= {'First Name'} 
                                  name= {'FirstName'}
                                  value={this.state.addHeartRunner.FirstName} 
                                  placeholder = {t('First_Responder.Enter First Name')}
                                  handleChange = {this.handleInput}
                               
                                            /> {/* Name of the user */}
                            {this.validator.message(`${t('First_Responder.First Name')}`, this.state.addHeartRunner.FirstName, 'required|allowSwedish|min:2')}
                            </div>    

                                </div>
                              
                              </div>
                              <div className="form-group">
                                  <div className="row">
                                    <div className="col-md-1"></div>
                                      <div className="col-md-2 radio-label"> 
                                      <label htmlFor="OrganizationNumber" className="form-label">{t('First_Responder.Last Name')}*</label>
                                      </div> 
                                      <div className="col-md-8">
                                      <InputWithExtra
                                        type={'text'}
                                        icon="fa fa-user"
                                        title= {'Last Name'} 
                                        name= {'LastName'}
                                        value={this.state.addHeartRunner.LastName} 
                                        placeholder = {t('First_Responder.Enter Last Name')}
                                        handleChange = {this.handleInput}
                                        
                                      /> {/* Name of the user */}
                                    {this.validator.message(`${t('First_Responder.Last Name')}`, this.state.addHeartRunner.LastName, 'required|allowSwedish|min:2')}
                                  </div>     

                                </div>
                              
                              </div>
                              <div className="form-group">
                              <div className="row">
                              <div className="col-md-1"></div>
                                <div className="col-md-2 radio-label"> 
                                 <label htmlFor="OrganizationName" className="form-label">{t('First_Responder.Alias Name')}</label>
                                </div> 
                                <div className="col-md-8">
                                <InputWithExtra
                                  type={'text'}
                                  icon="fa fa-user"
                                  title= {'Alias Name'} 
                                  name= {'AliasName'}
                                  value={this.state.addHeartRunner.AliasName} 
                                  placeholder = {t('First_Responder.Enter Alias Name')}
                                  handleChange = {this.handleInput} /> 
                          </div>    

                                </div></div>
                        <div className="form-group">
                              <div className="row">
                              <div className="col-md-1"></div>
                                <div className="col-md-2 radio-label"> 
                                 <label htmlFor="RegionName" className="form-label">{t('Regions')}</label>
                                </div> 
                                <div className="col-md-8">
                               
                                  <div className="input-group">   
                                       <span className="input-group-addon">
                                         <i className="fa fa-area-chart" aria-hidden="true"></i>
                                      </span>
                                  <select  id="regionData"  className="form-control1"
                                            onChange={this.handleInput} 
                                            value = {this.state.addHeartRunner.RegionId}
                                            placeholder="Select" 
                                            ref="regionData"
                                            name= {'RegionId'}
                                            
                                        >
                                          
                                            {regionListOption}
                                        </select>
                                   
                                        </div>
                          </div>    

                                </div>
                                </div>
                                <div className="form-group">
                              <div className="row">
                              <div className="col-md-1"></div>
                                <div className="col-md-2 radio-label"> 
                                 <label htmlFor="UserType" className="form-label">{t('Roles')}</label>
                                </div> 
                                <div className="col-md-8">
                               
                                  <div className="input-group">   
                                       <span className="input-group-addon">
                                         <i className="fa fa-tasks" aria-hidden="true"></i>
                                      </span>
                               <select id="UserType" className="form-control1"
                                                    onChange={e => { this.permissionType(e)}}
                                                    value={this.state.addHeartRunner.UserType}
                                                    placeholder="Select"
                                                    ref="UserType"
                                                    name={'UserType'}
                                                >
                                                  {rolesType}
                                                    {/* <option value={'Superadmin'} key={'Superadmin'}>Superadmin</option>
                                                    <option value={'Admin'} key={'Admin'}>Admin</option>
                                                    <option value={'User'} key={'User'}>User</option> */}
                                                </select>
                                        </div>
                          </div>    

                                </div></div>
                               

                                 <div className="form-group">
                              <div className="row">
                              <div className="col-md-1"></div>
                                <div className="col-md-2 radio-label"> 
                                 <label htmlFor="Permission" className="form-label">{t('Permissionss')}</label>
                                </div> 
                                <div className="col-md-8">
                               
                                  <div className="input-group">   
                                       <span className="input-group-addon">
                                         <i className="fa fa-area-chart" aria-hidden="true"></i>
                                      </span>
                                     <CreatableSelect id="PermissionId" 
        className="dropdown"
        placeholder="Select Option"
        value={this.state.addHeartRunner.PermissionId} // set selected values
        options={this.state.addHeartRunner.Permissions} // set list of the data
        onChange={this.handlePermissionChange} // assign onChange function
          getOptionLabel  = {(option)=>option.Permission}
        getOptionValue = {(option)=>option.ID}
        isMulti
        isClearable
      />
                                   
                                        </div>
                          </div>    

                                </div>
                                </div>
                                
                                <div className="form-group">
                              <div className="row">
                              <div className="col-md-1"></div>
                                <div className="col-md-2 radio-label"> 
                                 <label htmlFor="OrganizationName" className="form-label">{t('First_Responder.Phone Code')}</label>
                                </div> 
                                <div className="col-md-8">
                               
                                  <div className="input-group">   
                                       <span className="input-group-addon">
                                         <i className="fa fa-globe" aria-hidden="true"></i>
                                      </span>
                                  <select  id="countryData"  className="form-control1"
                                            onChange={this.handleInput} 
                                            value = {this.state.addHeartRunner.CountryCode}
                                            placeholder="Select" 
                                            ref="countrycodeData"
                                            name= {'CountryCode'}
                                        >
                                            {countryListOption}
                                        </select>
                                        </div>
                          </div>    

                                </div></div>
                          
                              <div className="form-group">
                              <div className="row">
                                <div className="col-md-1"></div>
                                  <div className="col-md-2 radio-label"> 
                                   <label htmlFor="OrganizationNumber" className="form-label">{t('First_Responder.Phone Number')}*</label>
                                  </div> 
                                  <div className="col-md-8">              
                            <InputWithExtra
                               type={'text'}
                               icon="fa fa-phone"
                               title= {'Phone Number'} 
                               name= {'Phone'}
                               value={this.state.addHeartRunner.Phone} 
                               placeholder = {t('First_Responder.Enter Phone Number')}
                               handleChange = {this.handleInput}
                               
                                            />

                            {this.validator.message(`${t('First_Responder.Phone Number')}`, this.state.addHeartRunner.Phone, 'required|phoneValidation|min:8|max:15')}

                            </div>    

                                </div>
                              
                              </div>
                              <div className="form-group">
                              <div className="row">
                                <div className="col-md-1"></div>
                                  <div className="col-md-2 radio-label"> 
                                   <label htmlFor="OrganizationNumber" className="form-label">{t('First_Responder.Email ID')}*</label>
                                  </div> 
                                  <div className="col-md-8">                
                            <InputWithExtra
                               type={'text'}
                               icon="fa fa-envelope-o"
                               title= {'Email ID'} 
                               name= {'EmailId'}
                               value={this.state.addHeartRunner.EmailId} 
                               placeholder = {t('First_Responder.Enter Email')}
                               handleChange = {this.handleInput}
                               
                                            /> {/* Name of the user */}
                            {this.validator.message(`${t('First_Responder.Email ID')}`, this.state.addHeartRunner.EmailId, 'required|email')}

                              </div>    

                                </div>
                              
                              </div>
                              
                              {/* <div className="form-group">
                                <div className="row">
                                  <div className="col-md-1"></div>
                                    <div className="col-md-2 radio-label"> 
                                    <label htmlFor="OrganizationNumber" className="form-label">{t('First_Responder.Certification ID')}</label>
                                    </div> 
                                    <div className="col-md-8">
                                    <InputWithExtra
                                      type={'text'}
                                      icon="fa fa-certificate"
                                      title= {'Certification ID'} 
                                      name= {'CertificateID'}
                                      value={this.state.addHeartRunner.CertificateID} 
                                      placeholder = {t('First_Responder.Enter Certification ID')}
                                      handleChange = {this.handleInput}
                                      
                                    /> 
                                </div>    

                              </div>
                          
                              </div> */}

                              <div className="form-group">
                                <div className="row">
                                  <div className="col-md-1"></div>
                                    <div className="col-md-2 radio-label"> 
                                    <label htmlFor="CPREducation" className="form-label">{t('First_Responder.CPREducation')} </label>
                                    </div> 
                                    <div className="col-md-8">
                                    <InputWithExtra
                                      type={'text'}
                                      icon="fa fa-certificate"
                                      title= {'CPREducation'} 
                                      name= {'CPREducation'}
                                      value={this.state.addHeartRunner.CPREducation} 
                                      placeholder = {t('First_Responder.CPREducation')}
                                      handleChange = {this.handleInput}
                                      
                                    />
                                </div>    
                              </div>
                              </div>
                              {/* <div className="form-group">
                                <div className="row">
                                  <div className="col-md-1"></div>
                                    <div className="col-md-2 radio-label"> 
                                    <label htmlFor="resourceName" className="form-label">Resource Name</label>
                                    </div> 
                                    <div className="col-md-8">
                                    <InputWithExtra
                                      type={'text'}
                                      icon="fa fa-database"
                                      title= {'Resource Name'} 
                                      name= {'resourceName'}
                                      value={this.state.addHeartRunner.resourceName} 
                                      placeholder = {'Enter Resource Name'}
                                      handleChange = {this.handleInput}
                                      
                                    /> 
                               </div>    

                              </div>
                          
                              </div> */}
                              {/* <div className="form-group">
                                <div className="row">
                                  <div className="col-md-1"></div>
                                    <div className="col-md-2 radio-label"> 
                                    <label htmlFor="OrganizationNumber" className="form-label">{t('First_Responder.Organization')}</label>
                                    </div> 
                                    <div className="col-md-8">
                                    <InputWithExtra
                                      type={'text'}
                                      icon="fa fa-building"
                                      title= {'Organization'} 
                                      name= {'Organization'}
                                      value={this.state.organizationName}
                                      
                                    /> 
                             
                                </div>    

                              </div>
                          
                            </div> */}
                              <div className="form-group">
                              <div className="row">
                                <div className="col-md-1"></div>
                                  <div className="col-md-2 radio-label"> 
                                   <label htmlFor="User Name" className="form-label">{t('First_Responder.User Name')}</label>
                                  </div> 
                                  <div className="col-md-8">
                            
                            <InputWithExtra
                                className="form-control1 hide-text-field"
                               type={'text'}
                               icon="fa fa-user-circle-o"
                               title= {'User Name'} 
                               name= {'Username'}
                               value={this.state.addHeartRunner.EmailId}
                               
                               handleChange = {this.handleInput}
                               
                                            /> {/* Name of the user */}
                            {/* {this.validator.message('Username', this.state.addHeartRunner.Username, 'required|min:6')} */}

                            </div>    

                                </div>
                              
                              </div>
                              <div className="form-group">
                              <div className="row">
                                <div className="col-md-1"></div>
                                  <div className="col-md-2 radio-label"> 
                                   <label htmlFor="Password" className="form-label">{t('First_Responder.Password')}*</label>
                                  </div> 
                                  <div className="col-md-8">
                            <InputWithExtra
                               autocomplete="new-password"
                               type={'password'}
                               icon="fa fa-key"
                               title= {'Password'} 
                               name= {'Password'}
                               value={this.state.addHeartRunner.Password} 
                               placeholder = {t('First_Responder.Enter Password')}
                               handleChange = {this.handleInput}
                               
                                            /> {/* Name of the user */}
                            {this.validator.message(`${t('First_Responder.Password')}`, this.state.addHeartRunner.Password, 'required|min:6')}

                            </div>    

                                </div>
                              
                              </div>
                              <div className="form-group">
                              <div className="row">
                                <div className="col-md-1"></div>
                                  <div className="col-md-2 radio-label"> 
                                   <label htmlFor="OrganizationNumber" className="form-label">{t('First_Responder.Confirm Password')}*</label>
                                  </div> 
                                  <div className="col-md-8">
                            <InputWithExtra
                               type={'Password'}
                               icon="fa fa-key"
                               title= {'Confirm Password'} 
                               name= {'confirmPassword'}
                               value={this.state.addHeartRunner.confirmPassword} 
                               placeholder = {t('First_Responder.Enter Password')}
                               handleChange = {this.handleInput}
                               autocomplete="new-password"
                                            /> {/* Name of the user */}
                              {this.validator.message(`${t('First_Responder.Confirm Password')}`, 
                              this.state.addHeartRunner.confirmPassword, 
                              `required|in:${this.state.addHeartRunner.Password}`, 
                              {messages: {in: `${t('First_Responder.Passwords need to match')}` }})
                              }
                              </div>     

                                </div>
                              
                              </div>
                              
                           
                            <div className="form-group"> 
                                        <div className="col-sm-12 add-first-sav-btn">      
                                <p>
                                
                                <button 
                                  type="button" 
                                  className="btn btn-primary" 
                                  disabled={this.props.addHeartRunnerDetails.isLoading == true}
                                  onClick={() => { this.addHeartRunner() }}
                                  >{t('First_Responder.Save')}
                                </button>
                                  {
                                    this.props.addHeartRunnerDetails.isLoading?  
                                      <img src={loader} width="30" alt="" />:''
                                  }
                                </p>
                                </div>
                            </div>
                        </form>
                        </div>
                    </div>
                    </div>
    
                </div>
            </div>
        )
    }
}

export default withNamespaces()(withRouter(AddHeartRunnerComponent));

